import { evaluateMechanicalValue } from "../../EvaluateExpression";
function tryParseWidthInMeters(width) {
    try {
        const evaluated = evaluateMechanicalValue(width, true);
        if (typeof evaluated === "object" && "toNumber" in evaluated) {
            return evaluated.toNumber("m");
        }
        if (typeof evaluated === "string") {
            return undefined;
        }
        return evaluated;
    }
    catch {
        return undefined;
    }
}
export function roundUpToNearestPreferredTraceWidth(preferredTraceWidths, traceWidthInMeters) {
    if (preferredTraceWidths.length === 0) {
        return traceWidthInMeters;
    }
    for (const preferredTraceWidth of preferredTraceWidths) {
        const preferredTraceWidthInMeters = tryParseWidthInMeters(preferredTraceWidth);
        if (preferredTraceWidthInMeters === undefined) {
            continue;
        }
        if (preferredTraceWidthInMeters >= traceWidthInMeters) {
            return preferredTraceWidthInMeters;
        }
    }
    return traceWidthInMeters;
}
//# sourceMappingURL=roundUpToNearestPreferredTraceWidth.js.map